import { Button } from '../atoms/Button/Button';
import { Inline } from '../atoms/Inline/Inline';
import { useTranslation } from '../../i18n/useTranslation';
import type { TimelineFilterType } from '../../types/timeline';
import './TimelineFilterChips.css';

interface FilterChipDef {
  key: TimelineFilterType;
  i18nKey: string;
}

const FILTERS: FilterChipDef[] = [
  { key: 'all', i18nKey: 'timeline.filter.all' },
  { key: 'water_tests', i18nKey: 'timeline.filter.waterTests' },
  { key: 'photos', i18nKey: 'timeline.filter.photos' },
  { key: 'journal', i18nKey: 'timeline.filter.journal' },
  { key: 'tasks', i18nKey: 'timeline.filter.tasks' },
  { key: 'livestock', i18nKey: 'timeline.filter.livestock' },
  { key: 'ai_insights', i18nKey: 'timeline.filter.aiInsights' },
];

interface TimelineFilterChipsProps {
  activeFilter: TimelineFilterType;
  onChange: (filter: TimelineFilterType) => void;
}

export function TimelineFilterChips({ activeFilter, onChange }: TimelineFilterChipsProps) {
  const { t } = useTranslation();

  return (
    <Inline gap="2" wrap className="timeline-filter-chips" role="group" aria-label={t('timeline.filter.label')}>
      {FILTERS.map(({ key, i18nKey }) => (
        <Button
          key={key}
          variant="ghost"
          className={`timeline-filter-chips__chip${activeFilter === key ? ' timeline-filter-chips__chip--active' : ''}`}
          onClick={() => { onChange(key); }}
          aria-pressed={activeFilter === key}
        >
          {t(i18nKey)}
        </Button>
      ))}
    </Inline>
  );
}
